import { NgModule } from '@angular/core';
import { QueuesService } from './services';

@NgModule({
  providers: [QueuesService]
})
export class DomainQueuesModule {}